import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Combines class names using clsx and tailwind-merge
 * This utility is used by all ShadCN components
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
